export default {
    userUrls: null,
    pageUrls: null,

    setUserUrls(userUrls = {}) {
        if (localStorage) {
            try {
                this.userUrls = userUrls;
                localStorage.setItem('mandyNavigation.userUrls', JSON.stringify(userUrls));
            } catch (e) {
                Bugsnag.notify('Anyone - Results@setDetailed:', 'localStorage error', { e });
            }
        }
    },

    setPageUrls(prev = null, next = null, back = null) {
        if (localStorage) {
            try {
                this.pageUrls = { prev, next, back };
                localStorage.setItem('mandyNavigation.pageUrls', JSON.stringify({ prev, next, back }));
            } catch (e) {
                Bugsnag.notify('Anyone - Results@setDetailed:', 'localStorage error', { e });
            }
        }
    },

    getNext(currentUid) {
        let userUrls = this.getUserUrls();
        if (!userUrls) {
            return null;
        }
        let currentIndex = userUrls.findIndex(user => user.uid === parseInt(currentUid));
        if (currentIndex === -1) {
            return null;
        }
        if (userUrls[currentIndex + 1]) {
            return userUrls[currentIndex + 1].link;
        } else {
            return this.getPageUrls().next;
        }
    },

    getPrevious(currentUid) {
        let userUrls = this.getUserUrls();
        if (!userUrls) {
            return null;
        }
        let currentIndex = userUrls.findIndex(user => user.uid === parseInt(currentUid));
        if (currentIndex === -1) {
            return null;
        }
        if (userUrls[currentIndex - 1]) {
            return userUrls[currentIndex - 1].link;
        } else {
            return this.getPageUrls().prev;
        }
    },

    getBack(currentUid) {
        let userUrls = this.getUserUrls();
        if (!userUrls) {
            return null;
        }
        let currentIndex = userUrls.findIndex(user => user.uid === parseInt(currentUid));
        if (currentIndex === -1) {
            return null;
        }
        return this.getPageUrls().back;
    },

    getUserUrls() {
        if (!this.userUrls) {
            if (localStorage) {
                try {
                    this.userUrls = JSON.parse(localStorage.getItem('mandyNavigation.userUrls'));
                } catch (e) {
                    Bugsnag.notify('Anyone - Results@setDetailed:', 'localStorage error', { e });
                }
            }
        }
        return this.userUrls;
    },

    getPageUrls() {
        if (!this.pageUrls) {
            if (localStorage) {
                try {
                    this.pageUrls = JSON.parse(localStorage.getItem('mandyNavigation.pageUrls'));
                } catch (e) {
                    Bugsnag.notify('Anyone - Results@setDetailed:', 'localStorage error', { e });
                }
            }
        }
        return this.pageUrls;
    }
};